import { TabObject } from './tab-object.model';

export class TabListObject {

    private _tabList: Array<any>;

    constructor() {
        this._tabList = new Array();
    }

    add(tab: any) {
        this._tabList.push(tab);
    }

    getIndex(tabName: string): number {
        return this._tabList.filter(it => it.tab.name.includes(tabName))[0]['index'];
    }

    getTab(index: number): TabObject {
        return this._tabList.filter(it => it.index == index)[0]['tab'];

    }

}